var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon left"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "slider",
    cx: 14,
    cy: 4,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "slider_2",
    cx: 12,
    cy: 16,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "slider_3",
    cx: 5,
    cy: 10,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lines",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3C0.447716 3 0 3.44772 0 4C0 4.55228 0.447716 5 1 5H14C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H1ZM14 3H19C19.5523 3 20 3.44772 20 4C20 4.55228 19.5523 5 19 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3ZM1 9C0.447716 9 0 9.44772 0 10C0 10.5523 0.447716 11 1 11H5C4.44771 11 4 10.5523 4 10C4 9.44772 4.44771 9 5 9H1ZM5 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H5C5.55229 11 6 10.5523 6 10C6 9.44772 5.55229 9 5 9ZM1 15C0.447716 15 0 15.4477 0 16C0 16.5523 0.447716 17 1 17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H1ZM12 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H12C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.562bee07fea78ed5352f875c67edc620.svg";
export { ForwardRef as ReactComponent };